import * as Long from "long";
import { filter, map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { EventType } from "../../../balancing/types/BalancingCore";
import { TypeActionEventInfo } from "../../event/actionEventInfo";
import { actionPlayerLeagueInfo } from "../actionPlayerLeagueInfo";
export var epicCoopLeagueInfo = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionEventInfo.Received &&
            action.eventInfo !== undefined &&
            action.eventInfo.coopLeagueEvent !== undefined &&
            action.eventInfo.coopLeagueEvent[0] !== undefined &&
            state$.value.playerInfo.coopId !== undefined &&
            Long.ZERO.notEquals(state$.value.playerInfo.coopId);
    }), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.CoopLeagueInfo,
            props: {
                coopId: state$.value.playerInfo.coopId,
                eventId: action.eventInfo.coopLeagueEvent[0].eventId,
                playerId: state$.value.playerInfo.playerId,
            },
        });
    }), retry(), map(function (res) { return actionPlayerLeagueInfo(res, EventType.CoopLeague); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/league/epics/epicCoopLeagueInfo.ts
// module id = 1912
// module chunks = 3